import { TextInput, TextInputProps } from 'react-admin';

/**
 * React Admin v3+ converts cleared `TextInput` values from `''` to `null`.
 * Our backend expects empty strings when a field is cleared, so this wrapper
 * preserves `''` instead of sending `null`, and ensures `null/undefined`
 * values from the API render as empty inputs.
 *
 * Use this component instead of `TextInput` whenever the backend expects empty strings rather than `null`
 * for cleared text fields.
 */
const EmptyStringTextInput = (props: TextInputProps) => {
  return (
    <TextInput
      parse={(v) => (v === '' ? '' : v)} // keep form state as '' instead of null when cleared
      format={(v) => (v == null ? '' : v)} // ensure null/undefined from record displays as ''
      {...props}
    />
  );
};

export default EmptyStringTextInput;
